var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloseMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.723 5l3.882 3.882a.564.564 0 0 1 0 .79l.067-.067a.556.556 0 0 1-.79 0L5 5.723 1.118 9.605a.564.564 0 0 1-.79 0l.067.067a.555.555 0 0 1 0-.79L4.276 5 .395 1.118a.564.564 0 0 1 0-.79L.328.395a.555.555 0 0 1 .79 0L5 4.277 8.882.395a.564.564 0 0 1 .79 0L9.604.328a.555.555 0 0 1 .001.79L5.723 5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseMini);
export default __webpack_public_path__ + "static/media/icon_close_mini.81acef3e8e885f68b0a89d8bf379a6b9.svg";
export { ForwardRef as ReactComponent };